import KeyFactsOption from './KeyFactsOption';

export default KeyFactsOption;
